import actionType from "../constents/action.type";
import { getCookieData, setCookieData } from "../utils/commonFunction";
const initialState = {
    token: "",
};

function setTokenData(state, data) {
    let obj = Object.assign({}, state, data);
    setCookieData(obj.token);
    return obj;
}


//execute when load
try {
    const tokenObj = getCookieData();
    if (tokenObj) {
        initialState.token = tokenObj;
    }
} catch (e) {
    console.error(e);
}


const userStore = (state = initialState, action = {}) => {
    switch (action.type) {
        case actionType.SET_TOKEN:
            return setTokenData(state, action.payload);
            break;
        default:
            return state;
    }
}
export default userStore;